// Kickback Contracts Theme - Light Base with Neon Accents
export const theme = {
  colors: {
    bg: {
      page: '#FFFFFF',
      card: '#FFFFFF',
      secondary: '#F8F9FB',
      tertiary: '#F1F3F7',
    },
    primary: '#6C5CE7',
    neon: {
      blue: '#00D9FF',
      green: '#39FF14',
      pink: '#FF10F0',
      purple: '#BC13FE',
      yellow: '#FFFF00',
    },
    accent: {
      teal: '#20E3B2',
      salmon: '#FF7A59',
    },
    text: {
      primary: '#0B0B0B',
      secondary: '#5B6472',
      muted: '#9CA3AF',
      inverse: '#FFFFFF',
    },
    borders: '#E6E8EF',
    status: {
      success: '#20E3B2',
      warning: '#FFB84D',
      error: '#FF7A59',
      info: '#6C5CE7',
    },
    shadows: {
      sm: '0 2px 8px rgba(14, 15, 18, 0.06), 0 1px 3px rgba(14, 15, 18, 0.04)',
      md: '0 4px 16px rgba(14, 15, 18, 0.08), 0 2px 6px rgba(14, 15, 18, 0.06)',
      lg: '0 8px 24px rgba(14, 15, 18, 0.10), 0 4px 12px rgba(14, 15, 18, 0.08)',
      xl: '0 16px 48px rgba(14, 15, 18, 0.12), 0 8px 24px rgba(14, 15, 18, 0.10)',
    },
  },
  radius: {
    sm: '8px',
    md: '12px',
    card: '16px',
    cta: '24px',
  },
  fonts: {
    ui: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    heading: "'Space Grotesk', sans-serif",
  },
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
};

export default theme;
